/* unplugin-vue-components disabled */import script from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"

import "./message-customer-service.vue?vue&type=style&index=0&id=3ebfa544&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebfa544"]])

export default __exports__